<script>
        import { onMount } from 'svelte';
        import { goto } from "$app/navigation";
        import { fade, draw } from 'svelte/transition';
        import { cubicInOut, cubicOut, cubicIn } from 'svelte/easing';
        import { viewport } from '$lib/stores/shared.svelte.js';

        let { 
            text = 'button text here', 
            small = false,
            arrowSide = 'right',
            arrowDir = 'downRight', 
            hover = false,
            click, 
        } = $props();

        let textWidth = $state();

        let angle = $state({
            right: 315,
            left: 135,
            up: 225,
            down: 45,
            upRight: 270,
            upLeft: 180,
            downRight: 0,
            downLeft: 90,
        }[arrowDir]);

        let side = $state(arrowSide === 'left' ? 'row-reverse' : 'row');

        // $effect( () => {
        //     if (viewport < 768) {
        //         hover = false;
        //     };
        // });

    </script>
    
    
    <button 
        class={['' , { small }]}
        style="flex-direction: {side}"
        onclick={goto(click)}
        onmouseenter={() => hover = true}
		onmouseleave={() => hover = false}
        >

        <h3 class={["f-col align-fs gap-8", { small } ]} style="width: {textWidth};">
            <span bind:clientWidth={textWidth}>
                {text}
            </span>
            {#if hover}
                <svg 
                    class="line"
                    height="2" 
                    width="{textWidth}" 
                    xmlns="http://www.w3.org/2000/svg">
                    <path 
                        d="M0 0 H0 {textWidth} Z" 
                        stroke-width="2" 
                        in:draw={{speed: .5, duration: 900 , easing: cubicInOut }}
                        out:draw={{speed: .75, duration: 700, easing: cubicOut }}
                        />
                </svg>
            {/if}
        </h3>

        
        <svg 
            width="20" 
            height="20" 
            viewBox="0 0 20 20" 
            fill="none"
            class={[
                '', 
                { small },
                    ]}
            style="transform: rotate({angle}deg);"
            >
            <path d="
                M 1 1
                L 19 19
                M 19 1
                V 19
                M 1 19
                H 19
                "
                stroke-width=".25"
                stroke="currentColor"
                stroke-linecap="round"
                >
            </path>
        </svg>
    
    </button>

<style>

    button {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 1rem;
    }

    .row-reverse {
        flex-direction: row-reverse
    }

    svg.line {
            width: 100%;
            height: 2px;
        }

    svg path {
        pointer-events: none;
        position: absolute;
        stroke: white;
    }

    button {
        z-index: 3;
        cursor: pointer;
        padding: .25rem 0;
    } 
        

    h3 {
        height: 6rem;
        padding: 1.5rem 0;
    }

    h3 span {
        width: fit-content;
    }

    button, h3 {
        /* font-family: 'Bitter Variable', serif; */
        font-family: 'Inter Variable', sans-serif;
        font-size: clamp(1.25rem, -3.833rem + 4.5vw , 1.525rem);
        font-weight: 200;
        white-space: nowrap;
        color: var(--body-font-color);
        background: none;
    }

    svg {
        width: clamp(3rem, -2.158rem + 11.125vw ,6rem);
        height: clamp(3rem, -2.158rem + 11.125vw ,6rem);   
    }

/*SMALL */
    button.small {
        padding-top: calc(-1 * clamp(.25rem, -1.5rem + 9.35vw, 1.25rem));
        justify-content: center;
        align-items: flex-start;
        gap: .5rem;
    }

    h3.small {
        justify-content: flex-start;
        align-items: flex-start;
        height: 2rem;
        width: max-content;
        padding: 0;
        font-size: clamp(.25rem, 0.165rem + .9vw ,1rem);
        white-space: nowrap;
    }

    svg.small {
        width: 12%;
        height: fit-content;
        transform: scaleY(-1);
        padding-left: .125rem;
    }
/* NOTE ^ transform is way more efficient than using IF blocks, refactor code later */

    svg.small path{
        stroke-width: 1px;
    }

/* Mobile Breakpoint */

@media (max-width: 768px) {
    button, h3 {
        height: max-content;
        font-size: 1.325rem;
    }

    button {
        gap: .5rem;
    }

    button.small {
        margin-top: calc(-1 * clamp(.25rem, 1.5rem + 9.35vw, 2.25rem));
    }

    h3.small {
        font-size: var(--step-0);
    }

    h3 span {
        width: fit-content;
    }

    svg {
        width: 3rem;
        height: 3rem;
    }

}

    </style>